import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a10bd576"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "header-title"
}

import TopMenu from '@/layouts/AppLayoutHeader/TopMenu.vue'
import { RouteRecordName, useRoute } from 'vue-router'
import { computed, ref, shallowRef, watchEffect } from 'vue'
import { i18n } from '@/services/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutHeader',
  props: {
  isMobileLayout: { type: Boolean, required: true },
},
  emits: ['toggle-menu'],
  setup(__props, { emit: emits }) {

const route = useRoute()
const customHeaderComponent = shallowRef<any>(null)
const customProps = shallowRef({})
const customHeaderMFs: Array<RouteRecordName> = ['Fleet']
const isFleetHeader = ref(false)
const headerText = ref('')
const hiddenHeaderMFs: Array<RouteRecordName> = ['Onboarding']

const customHeaderNamings: Record<RouteRecordName, string> = {
  OrdersReference: 'OrderDetails',
}



const toggleMenu = () => {
  emits('toggle-menu')
}



const routeName = computed(() => String(route.name))

// TODO: this header customization should not be responsibility from Orcas shell
const setCustomHeader = () => {
  isFleetHeader.value = false
  switch (routeName.value) {
    case 'Fleet':
      headerText.value = i18n.global.t('fleet.headline')
      customHeaderComponent.value = null
      isFleetHeader.value = true
      break
  }
}

const setCustomTitleHeader = () => {
  customHeaderComponent.value = null
  isFleetHeader.value = false
  if (hiddenHeaderMFs.includes(routeName.value)) {
    headerText.value = ''
  } else {
    const moduleName = customHeaderNamings[routeName.value] || routeName.value
    const key = `${moduleName.toLowerCase()}.headline`
    headerText.value = i18n.global.t(key)
  }
}

watchEffect(() => {
  if (customHeaderMFs.includes(routeName.value)) {
    setCustomHeader()
  } else {
    setCustomTitleHeader()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", [
      { 'header-mobile': __props.isMobileLayout },
      { 'header-fleet': isFleetHeader.value },
    ]]),
    "data-test": "orcas-migration-header"
  }, [
    (customHeaderComponent.value)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(customHeaderComponent.value), {
          key: 0,
          props: customProps.value
        }, null, 8 /* PROPS */, ["props"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(headerText.value), 1 /* TEXT */)),
    _createVNode(TopMenu, {
      "is-mobile-layout": __props.isMobileLayout,
      onToggleMenu: toggleMenu
    }, null, 8 /* PROPS */, ["is-mobile-layout"])
  ], 2 /* CLASS */))
}
}

})